import { useEffect } from 'react';

const ScreenShortsDisable = () => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      // Block PrtSc (Print Screen) key
      if (event.keyCode === 44) {
        event.preventDefault();
      }

      // Block Windows+Shift+S
      if (event.key === 's' && event.shiftKey && event.metaKey) {
        event.preventDefault();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
};

export default ScreenShortsDisable;
